// Bannière d'abonnement : essai bientôt terminé, paiement en attente, résilié.
// Lecture seule signalée à l'utilisateur. Bouton vers le Customer Portal Stripe.
import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatErreur } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle, CreditCard, Clock, Loader2 } from "lucide-react";

const jours = (iso) => {
  if (!iso) return null;
  const d = Math.ceil((new Date(iso) - new Date()) / 86400000);
  return d;
};
const dateFr = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "");

export default function AbonnementBanniere() {
  const { abonnement, acces } = useAuth();
  const [chargement, setChargement] = useState(false);
  if (!abonnement || !acces) return null;

  const ouvrirPortail = async () => {
    setChargement(true);
    try {
      const { data } = await api.post("/abonnements/portail", { origin: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatErreur(e.response?.data?.detail));
      setChargement(false);
    }
  };

  const statut = abonnement.statut;
  let contenu = null;

  if (statut === "trial") {
    const j = jours(abonnement.date_fin_trial);
    if (j !== null && j <= 7) {
      contenu = {
        cls: "bg-amber-50 border-amber-300 text-amber-800", icone: Clock,
        texte: `Votre période d'essai se termine le ${dateFr(abonnement.date_fin_trial)}${j >= 0 ? ` (dans ${j} jour${j > 1 ? "s" : ""})` : ""}. Renseignez votre moyen de paiement pour continuer.`,
        bouton: "Renseigner ma carte",
      };
    }
  } else if (statut === "en_attente_paiement") {
    contenu = {
      cls: "bg-red-50 border-red-400 text-red-800", icone: AlertTriangle,
      texte: "Paiement en attente — mettez à jour votre moyen de paiement pour retrouver l'accès complet. (Accès en lecture seule)",
      bouton: "Mettre à jour le paiement",
    };
  } else if (statut === "résilié") {
    contenu = {
      cls: "bg-[#fff4e6] border-amber-300 text-[#8A4A4A]", icone: AlertTriangle,
      texte: `Votre abonnement se termine le ${dateFr(abonnement.date_prochain_paiement || abonnement.date_resiliation)}. Vous pouvez réactiver à tout moment depuis Paramètres.`,
      bouton: null,
    };
  } else if (statut === "expiré") {
    contenu = {
      cls: "bg-red-50 border-red-400 text-red-800", icone: AlertTriangle,
      texte: "Votre abonnement a expiré — accès en lecture seule. Réactivez depuis Paramètres pour retrouver l'accès complet.",
      bouton: null,
    };
  }

  if (!contenu) return null;
  const Icone = contenu.icone;

  return (
    <div data-testid="banniere-abonnement" className={`mb-4 rounded-lg border px-4 py-3 flex items-center justify-between gap-3 ${contenu.cls}`}>
      <div className="flex items-center gap-2 text-sm font-medium">
        <Icone className="h-5 w-5 shrink-0" />
        <span>{contenu.texte}</span>
      </div>
      {contenu.bouton && (
        <button data-testid="banniere-action" onClick={ouvrirPortail} disabled={chargement}
          className="shrink-0 inline-flex items-center gap-1.5 rounded-md bg-[#1D3D3D] text-white px-3 py-1.5 text-sm font-semibold hover:bg-[#2D5A5A]">
          {chargement ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />} {contenu.bouton}
        </button>
      )}
    </div>
  );
}
